export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14945.bb9311be.jpg";